import { Modal } from 'antd';
import { useOpen } from '../../../../hooks/useBoolean/useOpen';
import { DeviceModelEnum } from '../../../../uc-api-sdk';
import { OrderType } from '../../type';
import { DeviceReplacementCheckboxComponent, DeviceReplacementCheckboxComponentProps, DeviceReplacementValue } from '../DeviceReplacementCheckboxComponent/DeviceReplacementCheckboxComponent';
import { OrderInfoComponent } from '../OrderInfoComponent/OrderInfoComponent';
import { useModalConfigContext } from '../../../../contexts/ModalConfigContext/ModalConfigContext';
import { LoanerPhoneAssignFormComponent, LoanerPhoneAssignFormComponentProps } from '../../../enrollment/component/LoanerPhoneAssignFormComponent/LoanerPhoneAssignFormComponent';
import { LinkButton } from '../../../../uiComponent/LinkButton/LinkButton';
import { EllipsisComponent } from '../../../../uiComponent/EllipsisComponent/EllipsisComponent';

interface LoanerPhoneReplacementValue
  extends DeviceReplacementValue {
  deviceId?: string;
}

export interface LoanerPhoneReplacementComponentProps
  extends Omit<DeviceReplacementCheckboxComponentProps, 'children'> {
  value?: LoanerPhoneReplacementValue;
  onChange?: (value?: LoanerPhoneReplacementValue) => void;
  onUncheck?: (deviceId: string) => void;
}

export const LoanerPhoneReplacementComponent = ({
  value,
  onChange,
  onUncheck,
}: LoanerPhoneReplacementComponentProps) => {
  const {
    isChecked = false,
    deviceId,
    reason,
  } = value || {};
  const {
    isOpen,
    open,
    close,
  } = useOpen();
  const {
    getContainer: getModalContainer,
  } = useModalConfigContext();

  const handleOnChange: DeviceReplacementCheckboxComponentProps['onChange'] = (
    newValue
  ) => {
    const {
      isChecked = false,
      reason: newReason,
    } = newValue || {};
    if (isChecked && newReason && !deviceId) {
      // only automatically open the modal when it's initial change
      open();
    }
    if (!isChecked) {
      onChange?.({ isChecked, reason: newReason });
      onUncheck?.(deviceId as string);
      return;
    }
    onChange?.({
      ...value,
      isChecked,
      reason: newReason,
    });
  };

  const handleOnDeviceSubmit: LoanerPhoneAssignFormComponentProps['onSubmit'] = (
    loanDevice
  ) => {
    onChange?.({ ...value, deviceId: loanDevice?.deviceId || '' });
    close();
  };
  const handleOnCancelDeviceAssignment = () => {
    if (!deviceId) {
      onChange?.({ isChecked: false, reason });
    }
    close();
  };

  return (
    <>
      <DeviceReplacementCheckboxComponent
        value={{
          isChecked,
          reason,
        }}
        onChange={handleOnChange}
        showExtraContent={isChecked && !!reason && !!deviceId}
        extraContent={(
          <div className="flex f-w ai-c">
            <EllipsisComponent>
              Device ID:
              {' '}
              {deviceId || 'not assigned'}
            </EllipsisComponent>
            <LinkButton
              useBlueColor
              onClick={open}
              className="fs12"
            >
              Edit
            </LinkButton>
          </div>
        )}
      >
        <OrderInfoComponent
          type={OrderType.DEVICES}
          deviceModel={DeviceModelEnum.LOAN_DEVICE}
        />
      </DeviceReplacementCheckboxComponent>
      <Modal
        open={isOpen}
        onCancel={handleOnCancelDeviceAssignment}
        footer={null}
        getContainer={getModalContainer}
        destroyOnClose
      >
        <LoanerPhoneAssignFormComponent
          initialValues={{ deviceId }}
          onSubmit={handleOnDeviceSubmit}
          onCancel={handleOnCancelDeviceAssignment}
        />
      </Modal>
    </>
  );
};
